const ALCOHOL_PHENOL_INJECTION = 'alcoholPhenolInjection';
export default ALCOHOL_PHENOL_INJECTION;
